import { render } from "./NavButton.vue?vue&type=template&id=5267f2aa&scoped=true"
import script from "./NavButton.vue?vue&type=script&lang=js"
export * from "./NavButton.vue?vue&type=script&lang=js"

import "./NavButton.vue?vue&type=style&index=0&id=5267f2aa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5267f2aa"]])

export default __exports__